const BRAND_PRIMARY = "#07988f";
const BRAND_PRIMARY_HOVER = "#0b847d";
const BRAND_PRIMARY_ACTIVE = "#066c66";

const themes = {
  light: {
    token: {
      colorPrimary: BRAND_PRIMARY,
      colorInfo: BRAND_PRIMARY,
      colorLink: BRAND_PRIMARY,
      colorPrimaryHover: BRAND_PRIMARY_HOVER,
      colorInfoHover: BRAND_PRIMARY_HOVER,
      colorPrimaryActive: BRAND_PRIMARY_ACTIVE,
      colorInfoActive: BRAND_PRIMARY_ACTIVE,
      fontSize: 13,
      borderRadius: 4,
      fontFamily:
        "Open Sans,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
    },
  },
  dark: {},
};

export default themes;
